export default [
    require('../assets/dialog-images/book_bg.png'),
    require('../assets/dialog-images/image/pagebg.png'),
    require('../assets/dialog-images/image/1.png'),
    require('../assets/dialog-images/image/2.png'),
    require('../assets/dialog-images/image/3.png'),
    require('../assets/dialog-images/image/4.png'),
    require('../assets/dialog-images/image/5.png'),
    require('../assets/dialog-images/image/6.png'),
]